export default __webpack_public_path__ + "static/media/cross.1358f710.svg";